import { render, staticRenderFns } from "./hrd-trainee-detail.vue?vue&type=template&id=dbadc4d0"
import script from "./hrd-trainee-detail.vue?vue&type=script&lang=js"
export * from "./hrd-trainee-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports